import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralize } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsDirectory, CommandsListProps } from "./lib";
import { useCommands } from "./useCommands";

export const ApplyTemplateEntityBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { open } = useCommands();
    const {
        selectedApplyTemplateEntityCount = 0,
        applyTemplateEntityBulkPreparerOptions,
        applyTemplateEntityBulkReviewerOptions,
        applyTemplateEntityBulkManagerOptions,
    } = options;

    const heading = `${selectedApplyTemplateEntityCount} ${pluralize("entity", selectedApplyTemplateEntityCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {applyTemplateEntityBulkPreparerOptions && (
                <CommandItem
                    keywords={["preparer", "assign preparer", "set preparer"]}
                    onSelect={() =>
                        open(
                            CommandsDirectory.APPLY_TEMPLATE_ENTITY_BULK_PREPARER,
                            options,
                        )
                    }
                >
                    Set preparer
                </CommandItem>
            )}
            {applyTemplateEntityBulkReviewerOptions && (
                <CommandItem
                    keywords={["reviewer", "assign reviewer", "set reviewer"]}
                    onSelect={() =>
                        open(
                            CommandsDirectory.APPLY_TEMPLATE_ENTITY_BULK_REVIEWER,
                            options,
                        )
                    }
                >
                    Set reviewer
                </CommandItem>
            )}
            {applyTemplateEntityBulkManagerOptions && (
                <CommandItem
                    keywords={["manager", "assign manager", "set manager"]}
                    onSelect={() =>
                        open(
                            CommandsDirectory.APPLY_TEMPLATE_ENTITY_BULK_MANAGER,
                            options,
                        )
                    }
                >
                    Set manager
                </CommandItem>
            )}
        </Command.Group>
    );
};
